<app-master-detail-layout
    [isMobile]="isMobile"
    [showDetail]="printersModuleService.showDetailMobile()"
>
    <app-printers-list sidebarContent #sidebarContent />

    <div mainContent #mainContent class="tw-relative tw-h-full tw-w-full tw-min-h-0 tw-flex tw-flex-col">
        <div appUpgradeUiView class="tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"></div>
        <app-local-loader [loading]="localLoader.isLoading()" [message]="localLoader.message()" />
    </div>
</app-master-detail-layout>
